import React, { useState } from 'react';
import { handleUpload } from '../../utils/uploadHandler';

const UploadSection = ({ onUploadSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState('faqs'); // Changed from 'utterances' to 'faqs'
  const [uploadError, setUploadError] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setUploadError('');
  };

  const handleFileTypeChange = (e) => {
    setSelectedFileType(e.target.value);
  };

  const upload = async () => {
    if (!selectedFile) {
      setUploadError('Please select a file to upload.');
      return;
    }

    setIsUploading(true);
    setUploadError('');

    try {
      await handleUpload(selectedFile, selectedFileType);
      onUploadSuccess();
      setSelectedFile(null);
      setUploadError('Upload successful!');
    } catch (error) {
      console.error("Upload error:", error);
      setUploadError(error.message);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="space-y-2 transition-all duration-300 ease-in-out bg-white p-3 rounded shadow">
      <div className="flex flex-col">
        <label className="text-sm font-medium mb-1">File Type</label>
        <select
          value={selectedFileType}
          onChange={handleFileTypeChange}
          className="w-full p-2 border rounded"
        >
          <option value="faqs">FAQs</option>
          <option value="utterances">Utterances</option>
          <option value="answers">Answers</option>
        </select>
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-medium mb-1">Upload TSV File</label>
        <input
          type="file"
          accept=".tsv"
          onChange={handleFileChange}
          className="w-full p-1 text-sm border rounded"
        />
      </div>
      {uploadError && <p className="text-sm text-red-500">{uploadError}</p>}
      <button
        onClick={upload}
        className="w-full p-2 mt-2 rounded bg-blue-500 text-white"
        disabled={!selectedFile || isUploading}
      >
        {isUploading ? 'Uploading...' : 'Upload File'}
      </button>
    </div>
  );
};

export default UploadSection;